import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetch(params) {
  return await request({
    url: ENDPOINT.RECRUIMENT,
    method: "get",
    params,
  });
}

export async function create(data) {
  return await request({
    url: ENDPOINT.RECRUIMENT,
    method: "post",
    data,
  });
}

export async function update(id, data) {
  return await request({
    url: `${ENDPOINT.RECRUIMENT}/${id}`,
    method: "post",
    data,
  });
}

export async function removeFile(id) {
  return await request({
    url: `${ENDPOINT.DELETE_INTRODUCE_FILE}/${id}`,
    method: "post",
  });
}